import { h } from "preact";

export default function BlendedImage({ src, className = "", size }) {
  if (!src) return null;

  return (
    <div className={`product-form__blended-image ${className}`}>
      <img src={window.getSizedImageUrl(src, size)} />
    </div>
  );
}
